import React, { useState } from "react";
import { Card, Container } from 'react-bootstrap'
import { experienceData } from '../constants/experienceData'
import '../styles/experience.css'

export default function Experience() {
    const currentYear = new Date().getFullYear().toString();
    const [activeNavItem, setActiveNavItem] = useState(currentYear);
  // eslint-disable-next-line no-unused-vars
    const [expandedCards, setExpandedCards] = useState([]);

    const handleNavItemClicked = (year) => {
        if (year !== activeNavItem) {
            setActiveNavItem(year);
            setExpandedCards(new Set());
        }    
    };
    
    const uniqueYears = [...new Set(experienceData.flatMap(item => {
        if (item.year === 'Present') {
            return [currentYear];
        } else if (item.yearRange) {
            const [startYear, endYearRaw] = item.yearRange.split('-');
            const endYear = endYearRaw === 'Present' ? currentYear : endYearRaw;
            const years = [startYear];

            for (let i = parseInt(startYear) + 1; i <= Math.min(parseInt(endYear), parseInt(currentYear)); i++) {
                years.push(i.toString());
            }
            return years;
        } else {
            return [item.year];
        }
    }))]
    .filter(year => experienceData.some(item => 
        item.year === year || 
        (item.yearRange && (item.yearRange.includes(year) || (item.yearRange.endsWith('Present') && year === currentYear)))
    ))
    .sort((a, b) => b - a);

    const filteredData = experienceData.filter(item => {
        if (activeNavItem === currentYear) {
            return item.year === currentYear || 
                   (item.yearRange && (item.yearRange.endsWith('Present') || item.yearRange.includes(currentYear)));
        } else {
            return item.year === activeNavItem || (item.yearRange && item.yearRange.includes(activeNavItem));
        }
    });

    return (
        <section id='experience'>
            <h3>Experience</h3>
            <Container id='container'>
                <div id='experienceYear'>
                {uniqueYears 
                    ? uniqueYears.map((year) => (
                            <p 
                                key={year}
                                id='yearBtn' role='tab' 
                                tabIndex={year}
                                onClick={() => handleNavItemClicked(year)}
                                className={year === activeNavItem ? 'active' : ''}
                            >{year === currentYear ? "Present" : year}</p>
                    )) : null}
                </div>

                {activeNavItem && (
                    <div id='card-container'> 
                        {filteredData.map(filteredItem => (
                        <Card id='experienceCard' key={filteredItem.id}>
                            <Card.Title style={{ marginBottom: '0.5rem', marginLeft:'1rem', marginTop:'0.5rem' }}>{filteredItem.name}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '0.5rem' }}>
                                    <p style={{color:'grey'}}>{filteredItem.institute}</p>
                                    <p style={{marginRight:'1rem'}}>{filteredItem.yearRange && filteredItem.yearRange.split('-').join(' - ')}</p>
                                </div>
                            </Card.Title>
                            <Card.Body style={{ marginTop: 0, paddingTop: 0, fontSize:'16px' }}>{filteredItem.description}</Card.Body>
                        </Card>                           
                        ))}
                    </div>
                )}
            </Container>
        </section>
    );
}